import { QueryClientProvider } from '@tanstack/react-query';
import { applyTheme, initialTheme } from '@rooming/ui';
import { createQueryClient } from '@rooming/web-core';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

// Light or dark before the first paint (no flash of the other theme).
applyTheme(initialTheme());

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
